<template>
    <background-image-rotator :classList="['image-container']" :media="media" :timing="15000"></background-image-rotator>
</template>

<script>
import axios from 'axios'
import BackgroundImageRotator from './Shared/BackgroundImageRotator.vue'

export default {
  props: {
    screen: {
      type: Number,
      required: true
    },
    prefill: {
      type: Array,
      require: false
    }
  },
  data () {
    return {
        interval: null,
        cachedData: [],
        media: []
    }
  },
  created () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, 1000 * 60 * 15)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {
      loadData () {
        axios.get(`https://gate01.se/api/elevators/images.php?screen_id=${this.screen}`)
        .then(response => {
          if (response && response.data) {
            this.cachedData = response.data.map(x => {
              return {
                type: (x.indexOf('.mp4') > 0) ? 'video' : 'image', 
                path: x
              }
            })
            this.media = this.cachedData
          }
        }).catch(() => {
            this.media = this.prefill.length ? this.prefill : this.cachedData
            // this.media = this.cachedData
        })
    }
  },
  components: {
    BackgroundImageRotator,
  }
}
</script>

<style lang="scss">
</style>
